import React from "react";
import "../EventGallery.css";

const DayOne2025 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2025/day-1/1.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/2.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/3.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/4.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/5.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/6.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/7.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/8.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/9.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/10.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/11.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/12.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/13.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/14.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/15.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/16.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/17.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/18.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/19.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/20.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/21.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/22.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/23.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/24.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/25.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-1/26.JPG",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2025 Day 1</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>
    </div>
  );
};

export default DayOne2025;